import classnames from "classnames";
import { Loader } from "./Loader";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { mergeClass } from "../utils";

export const PageContainer = ({
  isLoading,
  children,
  className,
}: {
  children: string | React.ReactNode;
  isLoading?: boolean;
  className?: string;
}) => (
  <div className={mergeClass("w-full h-full", className)}>
    {isLoading ? (
      <div className="w-full h-full grid place-content-center text-gray-500">
        <Loader />
      </div>
    ) : (
      children
    )}
  </div>
);

export const PageContent = ({
  children,
  className,
  reduceHeightForFooter,
}: {
  className?: string;
  children?: string | React.ReactNode;
  reduceHeightForFooter?: boolean;
}) => {
  const [displayedNote, setDisplayedNote] = useState<string | undefined>();

  return (
    <div
      className={mergeClass(
        "px-10 pt-8 pb-20 overflow-auto",
        {
          "pt-0": displayedNote,
          "h-full": !reduceHeightForFooter,
          "h-[calc(100%-5rem)]": reduceHeightForFooter,
        },
        className
      )}
    >
      {children}
    </div>
  );
};

export const PageFooterBar = ({
  children,
}: {
  children: React.ReactNode | string;
}): JSX.Element => (
  <div className="absolute bottom-0 grid content-center h-[5rem] w-full bg-white shadow-footerBar z-10">
    <div className="w-full flex justify-end gap-4 px-10">{children}</div>
  </div>
);
